// material-ui
import { styled } from "@mui/material/styles"
import { LinearProgressProps } from "@mui/material/LinearProgress"
import { CircularProgress } from "@mui/material"

// loader style
const LoaderFullPageWrapper = styled("div")(({ theme }) => ({
  top: 0,
  left: 0,
  zIndex: 2001,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "50vh",
  "& > * + *": {
    marginTop: theme.spacing(2)
  }
}))

// ==============================|| Loader ||============================== //

export interface LoaderProps extends LinearProgressProps {}

const LoaderFullPage = () => (
  <LoaderFullPageWrapper>
    <CircularProgress color="secondary" sx={{ height: 2 }} />
  </LoaderFullPageWrapper>
)

export default LoaderFullPage
